import { CSSProperties, ReactNode } from 'react';
import { getResizedImage } from 'shared-helpers/common';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Page } from 'components/page';
import { Box } from 'components/common/box';

interface Props {
  appStyle?: CSSProperties;
  backgroundImage?: string;
  backgroundPosition?: string;
  children: ReactNode;
  padding?: number;
  showUser?: boolean;
  title?: string | React.ReactNode;
  width?: 'narrow' | 'medium' | 'wide';
  wrapInContainer?: boolean;
}

const PagePlain = ({
  appStyle,
  backgroundImage,
  backgroundPosition,
  children,
  padding,
  showUser = false,
  title,
  width,
  wrapInContainer = true
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="plain">
      <Page
        appStyle={appStyle}
        backgroundColor={theme.loginBackgroundColor}
        backgroundImage={
          backgroundImage !== undefined
            ? backgroundImage
            : theme.loginBackgroundImage
            ? getResizedImage({ url: theme.loginBackgroundImage, size: 1920 })
            : null
        }
        backgroundPosition={
          backgroundImage !== undefined
            ? backgroundPosition
            : theme.loginBackgroundImage
            ? theme.loginBackgroundImagePosition
            : undefined
        }
        pageContentStyle={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
        showLoginFooter={true}
        showUser={showUser}
        subheader={false}
      >
        {wrapInContainer ? (
          <div className="content">
            <Box padding={padding !== undefined ? padding : 25} title={title}>
              {children}
            </Box>
          </div>
        ) : (
          children
        )}
      </Page>

      <style jsx>{`
        .plain {
          height: 100%;
        }
        .content {
          margin: 5vh 15px 10vh;
          flex-basis: 320px;
        }
        .header {
          padding: 10px 15px;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .content {
            flex-basis: ${width === 'wide'
              ? '800px'
              : width === 'medium'
              ? '480px'
              : '320px'};
          }
        }
      `}</style>
    </div>
  );
};

export default PagePlain;
